// Shared logic deciding whether an account can create a given channel type.
// Used by both ChannelList (to filter which channels are shown) and
// ChannelItem (to decide badges/disabled state) so the two stay in sync.
//
// See AccountTemplate#disabled_feature_names and
// Api::V1::Accounts::InboxesController::CHANNEL_TYPE_FEATURE_FLAGS for the
// backend side of this same mapping, which is the actual enforcement; this
// is just the UI reflecting it.

const CHANNEL_TYPE_FEATURE_FLAGS = {
  api: 'channel_api',
  whatsapp: 'channel_whatsapp',
  whatsapp_lite: 'channel_whatsapp_lite',
  sms: 'channel_sms',
  telegram: 'channel_telegram',
  line: 'channel_line',
  sip: 'channel_sip',
};

// Channels with no feature flag mapping that have always been allowed.
const ALWAYS_ALLOWED_CHANNELS = ['twilio'];

export const isChannelActive = (key, enabledFeatures) => {
  if (!enabledFeatures || Object.keys(enabledFeatures).length === 0) {
    return false;
  }

  if (key === 'website') {
    return !!enabledFeatures.channel_website;
  }
  if (key === 'facebook') {
    return !!(
      enabledFeatures.channel_facebook && window.chatwootConfig?.fbAppId
    );
  }
  if (key === 'email') {
    return !!enabledFeatures.channel_email;
  }
  if (key === 'instagram') {
    return !!(
      enabledFeatures.channel_instagram && window.chatwootConfig?.instagramAppId
    );
  }
  if (key === 'tiktok') {
    return !!(
      enabledFeatures.channel_tiktok && window.chatwootConfig?.tiktokAppId
    );
  }
  if (key === 'voice' || key === 'whatsapp_call') {
    return !!enabledFeatures.channel_voice;
  }
  if (key in CHANNEL_TYPE_FEATURE_FLAGS) {
    return !!enabledFeatures[CHANNEL_TYPE_FEATURE_FLAGS[key]];
  }

  return ALWAYS_ALLOWED_CHANNELS.includes(key);
};

// 'voice' is advertised as a teaser even when the account doesn't have
// access yet, instead of being hidden outright like other locked channels.
export const isChannelComingSoon = (key, enabledFeatures) => {
  return key === 'voice' && !isChannelActive(key, enabledFeatures);
};

// Channels the account should see at all: either it has access, or the
// channel is explicitly shown as a "coming soon" teaser.
export const isChannelVisible = (key, enabledFeatures) => {
  return (
    isChannelActive(key, enabledFeatures) ||
    isChannelComingSoon(key, enabledFeatures)
  );
};
